<template>
    <div class="article-venue-title">
        <p>
            <strong>St Chad’s Parish Centre<br /></strong>Otley Road, Far Headingley, Leeds, LS16 5JT <br /><a
                href="https://www.google.co.uk/maps/place/St+Chad%E2%80%99s+Parish+Centre/@53.8285929,-1.5866954,17z/data=!3m1!4b1!4m5!3m4!1s0x4879593941154ce9:0xfdc33bf1b120c29f!8m2!3d53.8285983!4d-1.5844973"
                target="_blank"
                rel="noopener noreferrer nofollow"
                >Google Maps</a
            >
        </p>
        <image-general
            :src="$config.public.images + 'st-chads-exterior.jpg'"
            imageAspectRatio="aspect-video"
        ></image-general>
    </div>
</template>

<script>
export default {
    name: 'ArticleVenueTitle',
};
</script>
